export default __webpack_public_path__ + "static/media/equityservice.6199219e.png";